export default __webpack_public_path__ + "static/media/62F9C48F-1591-4EA5-A792-722C18569895.ec7b4337.jpeg";